import { useTranslation } from 'react-i18next';
import { ReactFlowProvider } from 'reactflow';
import { useTheme, Box, Typography, CircularProgress, Backdrop, Paper, IconButton, Divider } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

import { CallsMenuContextProvider } from '@frontend/features/calls-menu/CallsMenuContext';
import { Diagram } from '@frontend/features/calls-menu/components';

const CallsMenuContent = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  const handleGoBack = () => {};

  return (
    <>
      <Backdrop
        open={false}
        style={{
          position: 'absolute',
          height: '100%',
          width: '100%',
          top: 0,
          left: 0,
          backgroundColor: theme.palette.action.disabledBackground,
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
      >
        <Box
          sx={{
            position: 'fixed',
            height: '100vh',
            width: '100vw',
            top: 0,
            left: 0,
            zIndex: theme.zIndex.drawer + 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      </Backdrop>
      <Box
        display="flex"
        sx={{
          height: 'calc(100vh - 64px)',
          width: '100%',
        }}
      >
        <Paper
          elevation={4}
          sx={{
            backgroundColor: theme.palette.common.white,
            zIndex: 1,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: 2,
            margin: theme.spacing(3),
            position: 'fixed',
          }}
        >
          <Box p={2} gap={2} display="flex" flexDirection="row" alignItems="center" alignSelf="stretch">
            <IconButton onClick={handleGoBack} sx={{ p: 0.5 }}>
              <ArrowBack color="primary" />
            </IconButton>
            <Divider sx={{ height: 32 }} orientation="vertical" flexItem />
            <Typography variant="subtitle2" color="text.primary">
              {t('agencies.settings.callsMenu')}
            </Typography>
          </Box>
        </Paper>
        <Diagram />
      </Box>
    </>
  );
};

const CallsMenu = () => (
  <ReactFlowProvider>
    <CallsMenuContextProvider>
      <CallsMenuContent />
    </CallsMenuContextProvider>
  </ReactFlowProvider>
);

export default CallsMenu;
